import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UX2, constants } from '@wsb/guac-widget-core';
import { ProductDetailStore } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { ProductDetailBase } from '../../ProductDetail/Base';
import useDevice, { devices } from '../../../hooks/useDevice';
import * as Metrics from '../../utils/trackMetric';
import * as MetricEvents from '../../../../constants/metrics';

const { Z_INDEX_FULL_SCREEN_OVERLAY } = constants.layers;

const modalStyle = {
  backgroundColor: 'modalOverlay',
  zIndex: Z_INDEX_FULL_SCREEN_OVERLAY
};

function QuickView({ productSlug, setQuickViewIsOpen, dataAid, renderMode, ...props }) {
  const [device] = useDevice();
  const modalWidth = device === devices.TABLET ? 700 : 1100;
  let initialOverflow = null;

  const disableScrolling = () => {
    if (initialOverflow === null && renderMode === 'PUBLISH') {
      initialOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  };

  const enableScrolling = () => {
    if (renderMode === 'PUBLISH') {
      document.body.style.overflow = initialOverflow;
      initialOverflow = null;
    }
  };

  useEffect(() => {
    ProductDetailStore.setState({ product: null, slug: productSlug });
    Metrics.track(MetricEvents.PRODUCT_LIST_QUICK_VIEW_MODAL_IMPRESSION);
    disableScrolling();
  }, [productSlug]);

  const handleModalClose = () => {
    Metrics.track(MetricEvents.PRODUCT_LIST_QUICK_VIEW_MODAL_CLOSE_CLICK);
    ProductDetailStore.setState({ product: null });
    enableScrolling();
    setQuickViewIsOpen(false);
  };

  return (
    <UX2.Element.Block data-aid={ dataAid }>
      <UX2.Component.Modal
        style={ modalStyle }
        closeOnClickOutside
        onClose={ handleModalClose }
        preventShrink
        width={ modalWidth }
      >
        <ProductDetailBase
          { ...props }
          renderMode={ renderMode }
          showSimilarProducts={ false }
          isQuickView
          closeQuickView={ () => {
            setQuickViewIsOpen(false);
            enableScrolling();
            ProductDetailStore.setState({ product: null });
          } }
          quickViewWidth={ modalWidth }
        />
      </UX2.Component.Modal>
    </UX2.Element.Block>
  );
}

QuickView.propTypes = {
  productSlug: PropTypes.string.isRequired,
  setQuickViewIsOpen: PropTypes.func,
  dataAid: PropTypes.string,
  renderMode: PropTypes.string
};

export default QuickView;
